import { call, put, takeLatest } from 'redux-saga/effects'
import { fetchAPI } from '../../../api/request';
import { actions } from '../slice';

function* fetchAll(action) {

    const { settings, params, query, body, token } = action.payload

    try {
        yield put({ type: actions.loadingChange.type })
        const response = yield call(fetchAPI, settings, params, query, body, token);
        yield put({ type: actions.dataChange.type, payload: response })
    } catch (error) {
        yield put({ type: actions.errorChange.type, error })
    }
}

export function* saga() {
    yield takeLatest(actions.fetchAllAction, fetchAll)
}